import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { RealisedGainLossDetailModel } from '../../../Models/Models/PortfolioAnalysis/Performance/RealisedGainLossDetailModel';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientRealisedGainLossClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>, fromDateTime: IJsonDate, toDateTime: IJsonDate, fromInception: boolean): Promise<Array<RealisedGainLossDetailModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/ClientRealisedGainLoss/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, fromDateTime: fromDateTime, toDateTime: toDateTime, fromInception: fromInception }

    return AjaxWrapper.get<Array<RealisedGainLossDetailModel>, any>(url, data);
  }
}

